import axios from "axios";
import getToken from "./getToken";
import { handleUnauthorizedError } from "./auth";

import { BASE_URL } from "../static/constants";

const http = axios.create({
  baseURL: BASE_URL,
  headers: {
    "Content-type": "application/json",
  },
  withCredentials: true,
});

http.interceptors.request.use(
  (config) => {
    const token = getToken();
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

http.interceptors.response.use(
  (response) => response,
  (error) => {
    const unauthorizedResult = handleUnauthorizedError(
      error.response?.status,
      error.config?.url,
      error.response?.data
    );
    if (unauthorizedResult) {
      return unauthorizedResult;
    }
    return Promise.reject(error);
  }
);

export default http;
